import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Title = styled.label`
  display: block;
  margin: 23px 0 14px;
  font-size: 14px;
  color: ${COLORS.gray60};

  &:first-child {
    margin-top: 0;
  }
`;

export default Title;
